/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 10/15/2019
 *
 */

const sidebarLinks =
[
  {
    id: 1,
    icon: "fa fa-lg fa-handshake-o",
    category: "Partner",
    isVisibleSubMenu: false,
    roles: ['ROLE_USER','ROLE_ADMIN'],
    subMenus: [
      {
        id: 11,
        icon: "fa fa-lg fa-users",
        link: "/home/partners",
        name: "Partners",
        roles: ['ROLE_USER','ROLE_ADMIN']
      },
      {
        id: 12,
        icon: "fa fa-lg fa-user",
        link: "/home/partnerRoles",
        name: "Partner Roles",
        roles: ['ROLE_USER','ROLE_ADMIN']
      },
      {
        id: 13,
        icon: "fa fa-lg fa-link",
        link: "/home/partnerUrls",
        name: "Partner URLs",
        roles: ['ROLE_USER','ROLE_ADMIN']
      },
      {
        id: 14,
        icon: "fa fa-lg fa-code",
        link: "/home/partnerUrlTypes",
        name: "Partner URL Type",
        roles: ['ROLE_ADMIN']
      }
    ]
  },
  {
    id: 2,
    icon: "fa fa-lg fa-building-o",
    category: "LMS",
    isVisibleSubMenu: false,
    roles: ['ROLE_ADMIN'],
    subMenus: [
      {
        id: 21,
        icon: "fa fa-lg fa-list-alt",
        link: "/home/lms",
        name: "LMS Definitions",
        roles: ['ROLE_ADMIN']
      },
      {
        id: 22,
        icon: "fa fa-lg fa-archive",
        link: "/home/lms-properties",
        name: "LMS Properties",
        roles: ['ROLE_ADMIN']
      },
      {
        id: 23,
        icon: "fa fa-lg fa-xing",
        link: "/home/lmsUrls",
        name: "LMS URLs",
        roles: ['ROLE_ADMIN']
      },
      {
        id: 24,
        icon: "fa fa-lg fa-openid",
        link: "/home/lmsUrlTypes",
        name: "LMS URL Types",
        roles: ['ROLE_ADMIN']
      }
    ]
  },
  {
    id: 3,
    icon: "fa fa-lg fa-university",
    category: "Institution",
    isVisibleSubMenu: false,
    roles: ['ROLE_USER','ROLE_ADMIN'],
    subMenus: [
      {
        id: 31,
        icon: "fa fa-lg fa-trello",
        link: "/home/institutions",
        name: "Institutions",
        roles: ['ROLE_USER','ROLE_ADMIN']
      },
      {
        id: 32,
        icon: "fa fa-lg fa-eur",
        link: "/home/institutionUrls",
        name: "Institution URLs",
        roles: ['ROLE_USER','ROLE_ADMIN']
      }
    ]
  },
  {
    id: 34,
    icon: "fa fa-lg fa-book",
    category: "Course",
    isVisibleSubMenu: false,
    roles: ['ROLE_PRODUCT_ADMIN'],
    subMenus: [
      {
        id: 34,
        icon: "fa fa-unlock",
        link: "/home/institutionUnblock",
        name: "Course Creation Block / Unblock",
        roles: ['ROLE_PRODUCT_ADMIN']
      }
    ]
  },
  // {
  //   id: 4,
  //   icon: "fa fa-lg fa-file-text",
  //   category: "Tool Profile",
  //   isVisibleSubMenu: false,
  //   roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER'],
  //   subMenus: [
  //     {
  //       id: 41,
  //       icon: "fa fa-lg fa-pencil-square-o",
  //       link: "/home/toolProfile",
  //       name: "Create Tool Profile",
  //       roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
  //     },
  //     {
  //       id: 42,
  //       icon: "fa fa-lg fa-stack-exchange",
  //       link: "/home/toolProfileManage",
  //       name: "Manage Tool Profile",
  //       roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
  //     }
  //   ]
  // },
  {
    id: 5,
    icon: "fa fa-lg fa-cogs",
    category: "Config",
    isVisibleSubMenu: false,
    roles: ['ROLE_ADMIN'],
    subMenus: [
      // {
      //   id: 51,
      //   icon: "fa fa-lg fa-stumbleupon",
      //   link: "/home/configUTF8ToolProfile",
      //   name: "Configure UTF-8 Tool Profile",
      //   roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
      // },
      // {
      //   id: 52,
      //   icon: "fa fa-lg fa-key",
      //   link: "/home/configUTF8ConsumerKey",
      //   name: "Configure UTF-8 ConsumerKey",
      //   roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
      // },
      // {
      //   id: 53,
      //   icon: "fa fa-lg fa-leanpub",
      //   link: "/home/configCustomFlowInstitution",
      //   name: "Configure custom flow institution",
      //   roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
      // },
      // {
      //   id: 54,
      //   icon: "fa fa-lg fa-street-view",
      //   link: "/home/configCustomFlowPartner",
      //   name: "Configure custom flow partner",
      //   roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
      // },
      // {
      //   id: 55,
      //   icon: "fa fa-lg fa-tachometer",
      //   link: "/home/configToolProviderIdentity",
      //   name: "Tool Provider Identity Configuration",
      //   roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
      // },
      {
        id: 56,
        icon: "fa fa-lg fa-tasks",
        link: "/home/audit",
        name: "Audit",
        roles: ['ROLE_ADMIN']
      },
      {
        id: 57,
        icon: "fa fa-lg fa-gavel",
        link: "/home/toolProviders",
        name: "Tool Providers",
        roles: ['ROLE_ADMIN']
      },
      {
        id: 58,
        icon: "fa fa-lg fa-database",
        link: "/home/logMaint",
        name: "Log Maint",
        roles: ['ROLE_ADMIN']
      }
    ]
  },
  {
    id: 6,
    icon: "fa fa-language",
    category: "UTF-8",
    isVisibleSubMenu: false,
    roles: ['ROLE_ADMIN'],
    subMenus: [
      {
        id: 61,
        icon: "fa fa-lg fa-tasks",
        link: "/home/utf8EnabledToolProfile",
        name: "Configure UTF-8 Tool Profile",
        roles: ['ROLE_ADMIN']
      },
      {
        id: 72,
        icon: "fa fa-weibo fa-2x",
        link: "/home/utf-enabled-consumer-key",
        name: "Consumer Key",
        roles: ['ROLE_ADMIN','ROLE_USER']
      }
    ]
  },
  {
    id: 7,
    icon: "fa fa-lg fa-braille",
    category: "Gradebook",
    isVisibleSubMenu: false,
    roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER'],
    subMenus: [
      {
        id: 71,
        icon: "fa fa-lg fa-calculator",
        link: "/home/view-audit",
        name: "View Audit",
        roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
      },
      {
        id: 72,
        icon: "fa fa-lg fa-support",
        link: "/home/view-error",
        name: "View Errors",
        roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
      }
    ]
  },
  // {
  //   id: 7,
  //   icon: "fa fa-lg fa-upload",
  //   category: "Cache",
  //   isVisibleSubMenu: false,
  //   roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER'],
  //   subMenus: [
  //     {
  //       id: 61,
  //       icon: "fa fa-lg fa-server",
  //       link: "/home/cacheSetup",
  //       name: "Cache Setup",
  //       roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
  //     },
  //     {
  //       id: 62,
  //       icon: "fa fa-lg fa-hdd-o",
  //       link: "/home/cacheReset",
  //       name: "Cache Reset",
  //       roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
  //     }
  //   ]
  // },
  {
    id: 8,
    icon: "fa fa-lg fa-male",
    category: "User",
    isVisibleSubMenu: false,
    roles: ['ROLE_ADMIN'],
    subMenus: [
      {
        id: 71,
        icon: "fa fa-lg fa-odnoklassniki",
        link: "/home/accounts",
        name: "Manage Users / Accounts",
        roles: ['ROLE_ADMIN']
      },
      {
        id: 72,
        icon: "fa fa-lg fa-user-plus",
        link: "/home/admin-roles",
        name: "Manage Admin Roles",
        roles: ['ROLE_ADMIN']
      }
    ]
  },
  {
    id: 9,
    icon: "fa fa-lg fa-film",
    category: "Roles",
    isVisibleSubMenu: false,
    roles: ['ROLE_USER','ROLE_ADMIN'],
    subMenus: [
      {
        id: 81,
        icon: "fa fa-lg fa-file-text-o",
        link: "/home/course-roles",
        name: "Manage Course Roles",
        roles: ['ROLE_USER','ROLE_ADMIN']
      },
      {
        id: 82,
        icon: "fa fa-lg fa-file-o",
        link: "/home/pearson-roles",
        name: "Manage Pearson Roles",
        roles: ['ROLE_ADMIN']
      }
    ]
  },
  {
    id: 10,
    icon: "fa fa-lg fa-history",
    category: "Logs",
    isVisibleSubMenu: false,
    roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER'],
    subMenus: [
      // {
      //   id: 91,
      //   icon: "fa fa-lg fa-language",
      //   link: "/home/outcomesLogs",
      //   name: "Outcomes CoreLogs",
      //   roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
      // },
      {
        id: 92,
        icon: "fa fa-lg fa-qrcode",
        link: "/home/coreLogs",
        name: "Core Logs",
        roles: ['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']
      }
    ]
  },
  {
    id: 11,
    icon: "fa fa-lg fa-sliders",
    category: "App Property",
    isVisibleSubMenu: false,
    roles: ['ROLE_ADMIN'],
    subMenus: [
      {
        id: 93,
        icon: "fa fa-lg fa-sliders",
        link: "/home/application-properties",
        name: "Application Properties",
        roles: ['ROLE_ADMIN']
      }
    ]
  },
  {
    id: 15,
    icon: "fa fa-lg fa-database",
    category: "Cache",
    isVisibleSubMenu: false,
    roles: ['ROLE_PRODUCT_ADMIN'],
    subMenus: [ {
      id: 96,
      icon: "fa fa-lg fa-database",
      link: "/home/cache-setup",
      name: "Cache Setup",
      roles: ['ROLE_PRODUCT_ADMIN']
    },
      {
        id: 96,
        icon: "fa fa-lg fa-database",
        link: "/home/cache-reset",
        name: "Cache Reset",
        roles: ['ROLE_PRODUCT_ADMIN']
      }]
  },
  {
    id: 12,
    icon: "fa fa-lg fa-ellipsis-h",
    category: "Other",
    isVisibleSubMenu: false,
    roles: ['ROLE_ADMIN'],
    subMenus: [
      {
        id: 94,
        icon: "fa fa-lg fa-folder-open",
        link: "/home/url-groups",
        name: "URL Groups",
        roles: ['ROLE_ADMIN']
      }
    ]
  },
  {
    id: 13,
    icon: "fa fa-lg fa-users",
    category: "Federations",
    isVisibleSubMenu: false,
    roles: ['ROLE_PRODUCT_ADMIN'],
    subMenus: [
      {
        id: 96,
        icon: "fa fa-lg fa-chain-broken",
        link: "/home/federations",
        name: "Account Unlinking",
        roles: ['ROLE_PRODUCT_ADMIN']
      }
    ]
  },
  // {
  //   id: 14,
  //   icon: "fa fa-weibo fa-2x",
  //   category: "Configure UTF-8",
  //   isVisibleSubMenu: false,
  //   roles: ['ROLE_ADMIN','ROLE_USER'],
  //   subMenus: [
  //     {
  //       id: 72,
  //       icon: "fa fa-weibo fa-2x",
  //       link: "/home/utf-enabled-consumer-key",
  //       name: "Consumer Key",
  //       roles: ['ROLE_ADMIN','ROLE_USER']
  //     }
  //   ]
  // }

 /* {
    id: 14,
    icon: "fa fa-weibo fa-2x",
    category: "Configure UTF-8",
    isVisibleSubMenu: false,
    roles: ['ROLE_ADMIN','ROLE_USER'],
    subMenus: [
      {
        id: 72,
        icon: "fa fa-weibo fa-2x",
        link: "/home/utf-enabled-consumer-key",
        name: "Consumer Key",
        roles: ['ROLE_ADMIN','ROLE_USER']
      }
    ]
  }*/

];

export default sidebarLinks;
